import React from "react";
import PropTypes from "prop-types";
import TitleBar from "../Layout/titleBar";
import { Row, Col } from "react-flexbox-grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import DragAndDropOferta from "../Common/dragAndDropOferta";
import "./styles.css";
class OfertaNuevo extends React.Component {
  render() {
    return (
      <div>
        {/* menú superior */}
        <TitleBar
          title={"Nueva oferta"}
          handleOnCancel={this.props.handleOnCancel}
          cancelarButtonLink="/Oferta"
          handleOnSave={this.props.handleOnSave}
        />

        <Row>
          <Col md={8}>
            <Paper className="myBox" style={{ marginTop: "32px", padding: "0px" }}>
              <div className="content line">
                <div style={{ height: "34px", paddingTop: "7px" }}>Datos de la oferta</div>
              </div>
              <div className="contentCampos">
                <Row>
                  <Col md={6}>
                    <TextField
                      className="myInput"
                      label="Nombre"
                      name="nombre"
                      fullWidth
                      required={true}
                      inputProps={{ maxLength: 255 }}
                      error={this.props.error && this.props.error.nombre}
                      helperText={
                        this.props.error && this.props.error.nombre ? this.props.error.nombre : ""
                      }
                      onChange={this.props.handleOnChange}
                    />
                  </Col>

                  <Col md={6}>
                    <TextField
                      className="myInput"
                      label="Tag"
                      name="tag"
                      fullWidth
                      required={true}
                      error={this.props.error && this.props.error.tag}
                      helperText={
                        this.props.error && this.props.error.tag ? this.props.error.tag : ""
                      }
                      onChange={this.props.handleOnChange}
                    />
                  </Col>
                </Row>

                <Row style={{ marginTop: "36px" }}>
                  <Col md={6}>
                    <TextField
                      className="myInput"
                      label="Desde"
                      name="startDate"
                      fullWidth
                      InputLabelProps={{ shrink: true, required: true }}
                      type="date"
                      error={this.props.error && this.props.error.fechaDesde}
                      helperText={
                        this.props.error && this.props.error.fechaDesde
                          ? this.props.error.fechaDesde
                          : ""
                      }
                      onChange={(e) => this.props.handleOnClickDia({ fechaDesde: e.target.value })}
                      InputProps={{ inputProps: { max: "9999-12-31" } }}
                    />
                  </Col>

                  <Col md={6}>
                    <TextField
                      className="myInput"
                      label="Hasta"
                      name="endDate"
                      fullWidth
                      InputLabelProps={{ shrink: true, required: true }}
                      type="date"
                      error={this.props.error && this.props.error.fechaHasta}
                      helperText={
                        this.props.error && this.props.error.fechaHasta
                          ? this.props.error.fechaHasta
                          : ""
                      }
                      onChange={(e) => this.props.handleOnClickDia({ fechaHasta: e.target.value })}
                      InputProps={{ inputProps: { max: "9999-12-31" } }}
                    />
                  </Col>
                </Row>
              </div>
            </Paper>
          </Col>

          <Col md={4}>
            <Paper className="myBox boxImage">
              <div className="content line">
                <div style={{ height: "34px", paddingTop: "7px" }}>Cucarda</div>
              </div>

              <>
                <DragAndDropOferta
                  accept="image/jpeg, image/png"
                  message="Arrastra una imagen o"
                  messageBottom={
                    this.props.ofertaSelected ? this.props.ofertaSelected.observacion : undefined
                  }
                  handleOnDrop={this.props.handleOnDropFile}
                  multiple={false}
                />
                {this.props.error && this.props.error.imagen && (
                  <p className="imageErrorMessage">{this.props.error.imagen}</p>
                )}
              </>

              <>
                {this.props.pathImg && (
                  <div className="containerArchivoSubido">
                    <img alt="" className="image" src={this.props.pathImg}></img>
                  </div>
                )}
              </>
            </Paper>
          </Col>
        </Row>
      </div>
    );
  }
}

OfertaNuevo.propTypes = {
  ofertas: PropTypes.array.isRequired,
  handleOnSave: PropTypes.func.isRequired,
  handleOnCancel: PropTypes.func.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnDropFile: PropTypes.func.isRequired,
};

OfertaNuevo.defaultProps = {
  ofertas: [],
  handleOnCancel: (f) => f,
  handleOnSave: (f) => f,
  handleOnChange: (f) => f,
  handleOnDropFile: (f) => f,
};

export default OfertaNuevo;
